import { useContext, createContext } from "react";

/**
 * Context Object via react Context API. Enables an app wide usable state for components
*/

export const AppContext = createContext(null);

export function useAppContext() {
    return useContext(AppContext);
}
